/* ==========================================================================
   Ryse - Theoric: monta o RODAPE do menu do celular

   Romulo, 12/07/2026:
     1. icones de Instagram e TikTok
     2. uma linha divisoria
     3. Minha conta - logado: "Ola (nome)" + "Seus pedidos"
     4. "Duvidas? Fale conosco"

   >>> NADA AQUI E CHUMBADO. <<<
     redes ...... settings.social_* (Personalizar > Configuracoes > Redes sociais)
     conta ...... customer / routes.account_url (o Liquid sabe quem esta logado)
     contato .... o proprio link "Fale Conosco" que ja existe no rodape do menu

   O contato e lido do DOM de proposito: ele vem do MENU cadastrado no admin. Se
   amanha trocarem o WhatsApp por um formulario, ou o numero mudar, esta linha segue o
   que o admin disser - sem ninguem tocar em codigo. (E se o item nao existir mais, o
   bloco simplesmente nao aparece: nada quebra.)

   >>> O QUE MUDA QUANDO ALGUEM ESTA LOGADO <<<
     deslogado:  [ Minha conta > ]
     logado:     Ola, Romulo
                 [ Seus pedidos > ]

   No modo de novas contas, o destino principal e a pagina "Minha bolsa" da loja.
   Pedidos e perfil continuam acessiveis como atalhos dentro dela.

   Carregado por snippets/theoric-menu-social.liquid.
   ========================================================================== */
(function () {
  var secao = document.getElementById('SidePopupMenu');
  if (!secao) return;

  var rodape = secao.querySelector('.mobile-megamenu__footer');
  if (!rodape) return;
  if (rodape.querySelector('.theoric-menu-social')) return;   /* ja montado */

  /* ------------------------------------------------------------- os desenhos */
  var ICONES = {
    instagram:
      '<path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23a3.7 3.7 0 0 1-.9 1.38c-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.31-1.46.72-2.13 1.38C1.35 2.68.94 3.35.63 4.14.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.79.72 1.46 1.38 2.13.67.67 1.34 1.08 2.13 1.38.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56.79-.31 1.46-.72 2.13-1.38.67-.67 1.08-1.34 1.38-2.13.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.9 5.9 0 0 0-1.38-2.13A5.9 5.9 0 0 0 19.86.63c-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0z"/><path d="M12 5.84A6.16 6.16 0 1 0 18.16 12 6.16 6.16 0 0 0 12 5.84zm0 10.16A4 4 0 1 1 16 12a4 4 0 0 1-4 4z"/><circle cx="18.41" cy="5.59" r="1.44"/>',
    tiktok:
      '<path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.6 2.6 0 0 1 0-5.2c.27 0 .53.05.77.12V9.66a5.7 5.7 0 0 0-.77-.06 5.7 5.7 0 1 0 5.7 5.7V8.99a7.35 7.35 0 0 0 4.29 1.37V7.27a4.26 4.26 0 0 1-3.25-1.45z"/>'
  };

  var SETA =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true" focusable="false" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';

  var NOMES = { instagram: 'Instagram', tiktok: 'TikTok' };

  /* ----------------------------------------------------------- os dados */
  var dados = {};
  var bruto = document.getElementById('theoric-menu-redes');
  if (bruto) {
    try { dados = JSON.parse(bruto.textContent) || {}; } catch (e) { dados = {}; }
  }

  var conta = dados.conta || {};

  /* ------------------------------------------------------- 1. as redes */
  var ativas = ['instagram', 'tiktok'].filter(function (rede) {
    return dados[rede] && String(dados[rede]).trim() !== '';
  });

  if (ativas.length) {
    var linha = document.createElement('div');
    linha.className = 'theoric-menu-social';

    ativas.forEach(function (rede) {
      var a = document.createElement('a');
      a.className = 'theoric-menu-social__link';
      a.href = dados[rede];
      a.target = '_blank';
      a.rel = 'noopener';   /* nao entrega o window.opener a terceiros */
      a.setAttribute('aria-label', NOMES[rede]);
      a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + ICONES[rede] + '</svg>';
      linha.appendChild(a);
    });

    rodape.insertBefore(linha, rodape.firstChild);   /* antes do divisor do tema */
  }

  /* --------------------------------------------- 3. conta  |  4. contato */
  var bloco = document.createElement('div');
  bloco.className = 'theoric-menu-conta';

  if (conta.logado && conta.nome) {
    var ola = document.createElement('p');
    ola.className = 'theoric-menu-conta__ola';
    ola.textContent = 'Olá, ' + conta.nome;
    bloco.appendChild(ola);
  }

  var link = document.createElement('a');
  link.className = 'theoric-menu-conta__link';

  if (conta.logado) {
    link.href = conta.url || '/account';
    link.innerHTML = '<span>' + (conta.rotulo || 'Minha conta') + '</span>' + SETA;
  } else {
    link.href = conta.login || conta.url || '/account/login';
    link.innerHTML = '<span>Minha conta</span>' + SETA;
  }

  bloco.appendChild(link);

  /* o contato sai do proprio menu do admin (o link "Fale Conosco" que ja estava no
     rodape). Se ele nao existir mais, nao inventamos um. */
  var antigo = rodape.querySelector('.mobile-megamenu__footer-links a[href*="wa.me"], .mobile-megamenu__footer-links a:last-child');
  if (antigo && antigo.getAttribute('href')) {
    var contato = document.createElement('a');
    contato.className = 'theoric-menu-contato';
    contato.href = antigo.getAttribute('href');

    if (/^https?:/i.test(contato.href) && contato.hostname !== window.location.hostname) {
      contato.target = '_blank';
      contato.rel = 'noopener';
    }

    contato.innerHTML = '<span>Dúvidas? Fale conosco</span>' + SETA;
    bloco.appendChild(contato);
  }

  rodape.appendChild(bloco);
})();
